import { render, staticRenderFns } from "./off-two-factor-auth .vue?vue&type=template&id=5ca09534&scoped=true&"
import script from "./off-two-factor-auth .vue?vue&type=script&lang=tsx&"
export * from "./off-two-factor-auth .vue?vue&type=script&lang=tsx&"
import style0 from "./off-two-factor-auth .vue?vue&type=style&index=0&id=5ca09534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca09534",
  null
  
)

export default component.exports